<template>
  <div>
    <generic-container
      :title="$t('human task tester')"
      icon="magic wand"
      style="margin-top: 15px"
      id="cntnr"
      ref="container"
      :header_buttons="header_buttons"
      :show_refresh="true"
      @refresh="refresh"
    >
      <div class="ui form" id="instance_form"></div>
      <!-- <pre>{{ args }}</pre> -->
    </generic-container>
  </div>
</template>

<script>
import GenericContainer from "@/components/GenericContainer";
import { error_toast, success_toast } from "@/utils";
import filters from "@/filters";
// import { cloneDeep } from "lodash";
import Vue from "vue";

export default {
  name: "NgineComposerHumanTaskTesterViewer",
  filters: filters,
  components: {
    GenericContainer,
  },
  data() {
    return {
      human_task: {},
      business_objects: [],
      task_vue: undefined,
      task_params: {},
      header_buttons: [{ icon: "red close", click: this.close }],
    };
  },
  computed: {
    // args() {
    //   let vm = this;
    //   if (vm.task_vue) {
    //     return vm.task_vue.$data;
    //   } else return {};
    // },
  },
  methods: {
    init(opts = {}) {
      let ht = opts.human_task;
      let environment = opts.environment;
      let vm = this;
      vm.$refs.container.set_loading(true);

      if (!window.jQuery("#instance_form").length) {
        let x = window.jQuery("#cntnr .bottom.attached.segment");
        x.html('<div class="ui form" id="instance_form"></div>');
      }

      ht.html = ht.html || "";
      ht.modifiers = ht.modifiers || [];
      ht.args = ht.args || [];
      ht.outcomes = ht.outcomes || [];
      vm.human_task = ht;

      let html = `<div class="ui basic icon labeled button"
                    v-for="(outcome, index) in outcomes"
                    :key="index"
                    style="margin-bottom: 20px"
                    @click="submit_data(outcome)"
                  >
                    <i :class="outcome.icon + ' icon'"></i> {{ outcome.name }}
                  </div>${ht.html}<div class="ui error message" />`;

      window.jQuery("#instance_form").html(html);

      setTimeout(() => {
        // eslint-disable-next-line no-unused-vars
        var mixin = {};
        var fields = {};
        // eslint-disable-next-line no-unused-vars
        let V = {};
        if (environment && environment.variables) {
          environment.variables.forEach((element) => {
            V[element.name] = element.value;
          });
        }

        // eslint-disable-next-line no-unused-vars
        var validate_on = [];
        try {
          // eslint-disable-next-line no-unused-vars
          // console.log("initializing modifiers");
          ht.modifiers
            .filter((m) => m.type == "js")
            .map((m) => {
              eval(m.code);
            });

          // console.log("initializing vue error handler");
          Vue.config.errorHandler = function (err) {
            console.error(err);
            error_toast(
              `${vm.$t(
                "an error ocurred during screen initialization",
              )}. ${vm.$t("error")}: ${err.toString()}`,
            );
          };

          let userTaskPayload = {};
          userTaskPayload.outcomes = ht.outcomes;

          // console.log("code mixin");
          if (ht.mixin) eval(`mixin = ${ht.mixin}`);
          // console.log("initializing vue object");
          // console.log("mixin", mixin);
          let data = {};
          if (mixin.data) data = mixin.data();
          vm.$emit("set_data", data);

          vm.task_vue = new Vue({
            el: "#instance_form",
            data: function () {
              let obj = {
                outcomes: ht.outcomes,
              };

              obj.form = undefined;
              return obj;
            },
            filters: filters,
            mixins: [mixin],
            methods: {
              submit_data(outcome) {
                let vm_ = this;
                if (outcome.validate) {
                  if (ht.validation) eval(`fields = ${ht.validation}`);
                  vm_.form
                    .form({
                      fields: fields,
                      onSuccess() {
                        vm_.do_submit(outcome);
                      },
                    })
                    .form("validate form");
                } else {
                  vm_.do_submit(outcome);
                }
              },
              do_submit(outcome) {
                success_toast(`${vm.$t("finished with")} ${outcome.name}`);
              },
            },
            mounted() {
              // console.log("mounted vue object");
              // let vm_ = this;
              // vm.$refs.container.set_loading(false);
              // vm_.form = window.jQuery(vm_.$el).form();
            },
          });
          setTimeout(() => {
            vm.$refs.container.set_loading(false);
          }, 600);
        } catch (error) {
          console.error(error);
          error_toast(error);
          vm.$refs.container.set_loading(false);
        }
      }, 1000);
    },
    close() {
      window.close();
    },
    refresh() {
      this.$emit("refresh");
    },
  },
  mounted() {},
  created() {},
  watch: {},
};
</script>

<style>
.pusher {
  margin-top: unset;
}

div#html_editor {
  width: 100%;
  min-height: 500px;
}
</style>
